import { tailwind as theme } from '@theme-ui/presets'

export default {
  ...theme,
  styles: {
    ...theme.styles
  },
  sizes: {
    container: '70ch'
  }
}